import ActionTypes from '../constants/ActionTypes';

const openModal = (type, data) => ({
  type: ActionTypes.MODAL_OPEN,
  payload: {
    type,
    data,
  },
});

const closeModal = () => ({
  type: ActionTypes.MODAL_CLOSE,
  payload: {},
});

export default {
  openModal,
  closeModal,
};
